export default "__VITE_ASSET__CB6FViL4__"